import FormTitle from "@/design/forms/FormTitle";

import { Box, Card, CardContent, Stack } from "@mui/material";
import PropTypes from "prop-types";

function Editor({ title, tabs, customHeader, children, actions, controls, id }) {
  return (
    <Card
      id={id}
      sx={{
        containerType: "inline-size",
      }}
    >
      <Box sx={{ borderBottom: (theme) => `1px solid ${theme.vars.palette.divider}` }}>
        {customHeader ? (
          <Box>
            {customHeader}
            {controls}
            {tabs && <Box sx={{ p: 2, pt: 0 }}>{tabs}</Box>}
          </Box>
        ) : (
          <CardContent>
            <FormTitle
              title={title}
              actions={
                <Stack
                  direction="row"
                  sx={{
                    gap: 0.5,
                  }}
                >
                  {actions}
                </Stack>
              }
            />
            {controls}
            {tabs}
          </CardContent>
        )}
      </Box>
      <Box
        sx={{
          display: "grid",
          ["@container (max-width: 800px)"]: {
            gridTemplateColumns: "1fr",
          },
          gridTemplateColumns: "minmax(0, 2fr) minmax(0, 1fr)",
          gridTemplateRows: "auto",
        }}
      >
        {children}
      </Box>
    </Card>
  );
}

Editor.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  tabs: PropTypes.node,
  children: PropTypes.node,
  customHeader: PropTypes.node,
  actions: PropTypes.node,
  controls: PropTypes.node,
};

export default Editor;
